import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Countries } from '../../components/selectlists';
import ChangeEmailModal from './changeemailmodal';
import SvgEditOutline from '../../icons/svgEditOutline';

import {
  updateUser,
} from '../../actions';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyHandle: '',
      emailOnLogin: '',
      submitted: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { dispatch, user } = this.props;

    let currencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currencyHandle = user.me.defaults.currencyHandle;
    }

    let emailOnLogin;
    if (user && user.me && user.me.flags && user.me.flags.emailOnLogin) {
      emailOnLogin = user.me.flags.emailOnLogin;
    }

    this.setState({
      currencyHandle,
      emailOnLogin,
    });
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { currencyHandle, emailOnLogin } = this.state;
    const data = {
      currencyHandle,
      emailOnLogin,
      action: 'verifyEmail',
    };
    dispatch(updateUser(data))
      .then((res) => {
        if (res.type === 'UPDATE_USER_SUCCESS') {
          this.setState({ submitted: true });
        }
      });
  }

  render() {
    const { submitted } = this.state;
    const { user, tempAnon } = this.props;
    const { me } = user;

    if (!user || !user.me.identity) {
      return (null);
    }

    let emailVerified;
    if (me && me.emailVerified) {
      emailVerified = me.emailVerified;
    }

    return (
      <div className="cell panel v2 small-12 medium-12 large-12">
        <div className="panel-label">
          Account Info
        </div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x">
              <div className="cell small-6 medium-9 large-9">
                <div className="grid-x group">
                  <div className="cell small-12 medium-6 large-6">
                    <div>Primary Email</div>
                  </div>
                  <div className="cell small-12 medium-6 large-6">
                    <span className={tempAnon ? 'eyeblur' : ''}>
                      {me.email}
                    </span>
                  </div>
                </div>
              </div>
              <div className="cell small-6 medium-3 large-3 grid-y group">
                <div className="cell small-12 medium-12 large-12 flex-end">
                  <div
                    className="vlt-i-btn sm"
                    onClick={() => this.props.toggleModal(<ChangeEmailModal toggleModal={this.props.toggleModal} modalComponent={this.state.modalComponent} wideModal={true}/>)}
                  >
                    <SvgEditOutline />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="cell small-12 medium-12 large-12">
            <hr />
          </div>

          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x">
              <div className="cell small-6 medium-9 large-9">
                <div className="grid-x group">
                  <div className="cell small-12 medium-6 large-6">
                    <div>Client ID</div>
                  </div>
                  <div className="cell small-12 medium-6 large-6">
                    <span className={tempAnon ? 'eyeblur' : ''}>
                      {me.referenceId}
                    </span>
                  </div>
                </div>
              </div>
              <div className="cell small-6 medium-3 large-3">
                <div className="grid-x group">
                  <div className="cell small-12 medium-12 large-12 flex-end">
                    { emailVerified ? (
                      <div className="vt-accent" style={{fontWeight: 600}}>
                        Verified
                      </div>
                    ) : (
                      <div
                        className="vlt-t-btn"
                        onClick={submitted ? (
                          null
                        ) : (
                          () => this.handleSubmit()
                        )}
                        disabled={submitted}
                      >
                        <span style={submitted ? { color: 'rgb(78, 199, 138)', opacity: 1 } : {fontWeight: '600'}}>
                          { submitted ? 'Verification Email Sent' : 'Resend Verification Email' }
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  tempAnon: state.user.tempAnon,
});

export default connect(mapStateToProps)(Account);
